import { PositionData } from "./position-data";
//WebSocket
let geoId: number | null = null;
let wss_g: WebSocket | null = null;

enum wss_codes {
    disconnected = 4000,
    normal = 1000,
    badCredentials = 4004,
    abnormal = 1006

}


//state
let playersPosition: Record<string,PositionData> = {}
let playerListener:Record<string,EventListener[]> = {}

let entryListener: EventListener[] = []
let keys:string[] = []

let bindings: [string, string] = ["", ""]

// geolocation
let lastSendPosition: GeolocationPosition | null = null 
const MINIMAL_TIME_BETWEEN_UPDATE = 1000 * 40 //milliseconds
const TIMEOUT_BETWEEN_UPDATE = 1000 * 10 //milliseconds
const GPS_TIMEOUT = 1000 * 8 //milliseconds
const MINIMAL_DISTANCE_BETWEEN_UPDATE = 10 //meters
const MINIMAL_ACCURACY_IMPORVEMENT = 5 //meters

// object with state management function
export const dynamicPositionStore = {
    subscribe(id:string,listener:EventListener) { //call with bind
        playerListener[id] = [...(playerListener[id] ?? []),listener]
        return () =>{
            playerListener[id] = playerListener[id].filter(l => l !== listener)
        }
    },
    subscribeNewEntry(listener:EventListener){
        entryListener.push(listener)
        return () =>{
            entryListener = entryListener.filter(l => l !== listener)
        }
    },

    // geters
    getPlayerCord(id:string): PositionData | null{
        return playersPosition[id] ?? null
    },

    getPlayersIds(){ // subscribe before get
        return keys 
    },

    // update data logic

    updateCallback(id:string,update:PositionData){
        const isNewEntry = playersPosition[id]===undefined;
        // const old = playersPosition[id]

        playersPosition[id] = update
        // TODO use reduce to miniamise 
        
        if(isNewEntry){
            keys = [...keys,id]
            playerListener[id]=[]
            for (let listener of entryListener){
                listener(new Event(""))
            }
        }
        else{
            for(let listener of playerListener[id]){
                listener(new Event(""))
            }
        }

        if(id === bindings[0] && bindings[0]!==bindings[1]){
          this.updateCallback(bindings[1], update)        
        }

    },

    bindTo(source: string, destination: string){
      bindings = [source, destination]
      this.updateCallback(destination, playersPosition[source] ?? null)
    },

    reconnectWs(userId:string){
        if(wss_g !== null){
            wss_g.close(wss_codes.normal)
        }
        setupWs(userId)
    },

    // register ws

    //TODO use somewhere
    setup(){
      fetch("/api/map/users").then(b => b.json()).then((b:{users: {_id:string,position:string}[]}) =>{
        for (const userPosition of b.users) {
          this.updateCallback(userPosition._id, JSON.parse(userPosition.position))
        }
      })
    }


}


function geoposDistance(a: GeolocationCoordinates, b: GeolocationCoordinates): number{
  // Equirectangular approximation
  const R = 6371e3 //meters
	const φ1 = a.latitude * Math.PI/180; // φ, λ in radians
	const φ2 = b.latitude * Math.PI/180;

	const λ1 = a.longitude * Math.PI/180; // φ, λ in radians
	const λ2 = b.longitude * Math.PI/180;

	const x = (λ2-λ1) * Math.cos((φ1+φ2)/2);
	const y = (φ2-φ1);
	const d = Math.sqrt(x*x + y*y) * R;
	return d;
}

function shouldSendGeoposition(geoposition: GeolocationPosition): boolean {
  if (!lastSendPosition) return true

  let distance = geoposDistance(lastSendPosition.coords, geoposition.coords)
  let time_difference = geoposition.timestamp - lastSendPosition.timestamp
  let accuracyImprovement = lastSendPosition.coords.accuracy - geoposition.coords.accuracy

  if(time_difference > MINIMAL_TIME_BETWEEN_UPDATE){ //ensure endpoints that it is indeed current position
    return true
  }

  if(time_difference < TIMEOUT_BETWEEN_UPDATE){
    return false
  }

  if(distance > MINIMAL_DISTANCE_BETWEEN_UPDATE && distance > lastSendPosition.coords.accuracy){
    return true
  }

  if(accuracyImprovement > MINIMAL_ACCURACY_IMPORVEMENT){
    return true
  }

  return false
}

function setupWs(userId:string) {
        // TODO: feature detection: WebSocket, navigator, geolocation, geolocation permission denied
        
        const protocol = ('https:' === document.location.protocol) ? "wss:":"ws:";
        
        
        let wss = new WebSocket(`${protocol}//${window.location.host}/ws`)

        wss.onmessage = msg => {
          // TODO: add error handling
          let data : {id: string, cord: PositionData} = JSON.parse(msg.data)
          console.log(data)
          if(data.id!==null && data.cord !== null)
            dynamicPositionStore.updateCallback(data.id,data.cord)// TODO check if this is valid format
        }
    
        wss.onerror = function(error){
          console.log("wss.onerror", error);
          this.close(wss_codes.disconnected) 
        }
    
        wss.onclose = e => {
          console.log("wss.onclose", e);
          window.navigator.geolocation.clearWatch(geoId!)
          geoId=null;
          
          if (e.code === wss_codes.badCredentials){
            console.log("wss.badCredentials")
            // window.location.href = "/?token=&id=" // logout
          }
          else if (e.code === wss_codes.disconnected || e.code === wss_codes.abnormal){ 
            setTimeout(()=> setupWs(userId),1000*5) // co 5 s reconnect
          }
        }

        if(geoId !== null){
            window.navigator.geolocation.clearWatch(geoId)
        }
        
        geoId = window.navigator.geolocation.watchPosition((position) => {
          let data : PositionData = {
            coords: [position.coords.latitude, position.coords.longitude],
            timestamp: position.timestamp, 
            accuracy: position.coords.accuracy
          }

          if(!shouldSendGeoposition(position)){
            return;
          }
          
          dynamicPositionStore.updateCallback(userId,data)
          if(wss.readyState === wss.OPEN){
            wss.send(JSON.stringify(data))
            lastSendPosition = position
          }
    
        }, (err) => {
          // TODO: of access is denied by user, give a proper prompt.
          if(err.code === err.PERMISSION_DENIED){
            window.alert("Geolocation permission is denied, check your system settings if this bechaviour is unexpected.")
          }
          console.log(err)
        }, {enableHighAccuracy: true, maximumAge: GPS_TIMEOUT})
        
    
        wss_g = wss  
}


